import React from 'react';

export const Filter: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.79644 6.38989C6.45259 6.38989 6.98328 5.85863 6.98328 5.20479C6.98328 4.55095 6.45259 4.01968 5.79644 4.01968C5.14029 4.01968 4.6096 4.55095 4.6096 5.20479C4.6096 5.85863 5.14029 6.38989 5.79644 6.38989ZM5.79644 7.22305C6.74607 7.22305 7.54266 6.56831 7.75866 5.686L14.6655 5.68599V4.85284L7.78583 4.85284C7.61917 3.90597 6.7919 3.18652 5.79644 3.18652C4.80098 3.18652 3.9737 3.90597 3.80705 4.85284H1.33499V5.686H3.83421C4.05022 6.56831 4.8468 7.22305 5.79644 7.22305Z" fill="black"></path>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2041 9.60952C9.5479 9.60952 9.01721 10.1408 9.01721 10.7946C9.01721 11.4485 9.5479 11.9797 10.2041 11.9797C10.8602 11.9797 11.3909 11.4485 11.3909 10.7946C11.3909 10.1408 10.8602 9.60952 10.2041 9.60952ZM10.2041 8.77637C9.27069 8.77637 8.48518 9.40886 8.25344 10.2683L1.33499 10.2683L1.33499 11.1014H8.20724C8.35515 12.0705 9.19283 12.8129 10.2041 12.8129C11.2153 12.8129 12.0529 12.0705 12.2009 11.1014L14.6655 11.1014V10.2683L12.1547 10.2683C11.9229 9.40886 11.1374 8.77637 10.2041 8.77637Z" fill="black"></path>
  </svg>
);

export const Close: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 18L11.9391 12M11.9391 12L6 6.12061M11.9391 12L18 6M11.9391 12L6 17.8794" stroke="black"></path>
  </svg>
);

export const Wishlist: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2L15.09 8.58255L22 9.64458L17 14.7655L18.18 22L12 18.5825L5.82 22L7 14.7655L2 9.64458L8.91 8.58255L12 2Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export const ChevronRight: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M9 18L15 12L9 6" stroke="black" stroke-linecap="square"/>
  </svg>  
);

export const ChevronLeft: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
  <path d="M15 18L9 12L15 6" stroke="black" stroke-linecap="square"/>
  </svg> 
);

export const Search: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg className="search" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.66652 8.72833L12.6258 12.6875M10.125 5.68753C10.125 8.10378 8.16625 10.0625 5.75 10.0625C3.33375 10.0625 1.375 8.10378 1.375 5.68753C1.375 3.27128 3.33375 1.31253 5.75 1.31253C8.16625 1.31253 10.125 3.27128 10.125 5.68753Z" stroke="currentColor"></path>
  </svg>
);